import * as React from 'react';
import { useEffect, Suspense } from "react";

import { Route, Routes, useNavigate } from "react-router-dom";

import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from './components/AppNavbar';
import Header from './components/Header';
import SideMenu from './components/SideMenu';
import Footer from '@component/Footer';
import AppTheme from '../shared-theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from './theme/customizations';

import LoadingPage from '@templates/shared-theme/pages/LoadingPage';

import DashboardPage from './pages/DashboardPage';
import ClubPage from './pages/ClubPage';
import SitePage from './pages/SitePage';
import PostsPage from './pages/PostsPage';
import AccountListPage from './pages/AccountListPage';
import NotificationsPage from './pages/NotificationsPage';
import ShopPage from './pages/ShopPage';
import ReservationsPage from './pages/ReservationsPage';
import ChallengesPage from './pages/ChallengesPage';
import RewardedActivitiesPage from "./pages/RewardedActivitiesPage";
import UserManagementPage from "./pages/UserManagementPage";

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function AdminPanel(props) {
  return (
    <AppTheme {...props} themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        
        <Routes>
          <Route path="/" exact element={<DashboardRedirect />} />
          <Route path="/dashboard" element={<Dashboard />} />

          {/* ============    CLUB    ============ */}
          <Route path="/club" element={<MyClub />} />

          {/* ============    SITE    ============ */}
          <Route path="/site/:uuid" element={<MySite />} />

          {/* ============    ACCOUNT    ============ */}
          <Route path="/admin-accounts" element={<AccountList />} />

          {/* ============    ChHALLES    ============ */}
          <Route path="/challenges/" element={<Challenges />} />

          {/* ============    POST    ============ */}
          <Route path="/communication/posts" element={<Posts />} />

          {/* ============    NOTIFICATION    ============ */}
          <Route path="/communication/notifications" element={<Notifications />} />

          {/* ============    SHOP    ============ */}
          <Route path="/shop" element={<Shop/>} />
          <Route path="/shop/reservations" element={<Reservations />} />

          {/* ============  REWARDED ACTIVITIES  ============ */}
          <Route path="/rewarded-activities" element={<RewardedActivities/>} />

          {/* ============  TRANSFER POINTS  ============ */}
          <Route path="/user-management" element={<UserManagement/>} />
          
          {/* ============    404 PAGE    ============ */}
          <Route path="*" element={<div>404 - Page Not Found</div>} />
        </Routes>

      </Box>
    </AppTheme>
  );
}

function DashboardRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/admin/dashboard');  
  }, [navigate]);

  return null;
}

function AbstractLayout(props) {
  return (
      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto'
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 0, // bug: ? this was 10 for some reason, idk if it should be so, but it looks stupid
            mt: { xs: 8, md: 0 },
            minHeight:'100vh'
          }}
        >
          <Header />

          
          <Suspense fallback={<LoadingPage/>}>
            <Box sx={{ flex: 1, width: '100%' }}>
              {props.children}
            </Box>
          </Suspense>

          {/* Add the Footer component at the bottom */}
          <Footer />
        </Stack>
      </Box>
  );
}

function Dashboard() {
  return (
    <AbstractLayout>
      <DashboardPage/>
    </AbstractLayout>
  );
}

function MyClub() {
  return (
    <AbstractLayout>
      <ClubPage/>
    </AbstractLayout>
  );
}

function MySite() {
  return (
    <AbstractLayout>
      <SitePage/>
    </AbstractLayout>
  );
}

function AccountList() {
  return (
    <AbstractLayout>
      <AccountListPage />
    </AbstractLayout>
  );
}



function Challenges() {
  return (
    <AbstractLayout>
      <ChallengesPage />
    </AbstractLayout>
  );
}

function Posts() {
  return (
    <AbstractLayout>
      <PostsPage />
    </AbstractLayout>
  );
}

function Notifications() {
  return (
    <AbstractLayout>
      <NotificationsPage />
    </AbstractLayout>
  );
}

function Reservations() {
  return (
    <AbstractLayout>
      <ReservationsPage />
    </AbstractLayout>
  );
}


function Shop(){
  return(
    <AbstractLayout>
      <ShopPage />
    </AbstractLayout>
  )
}
function RewardedActivities(){
  return(
    <AbstractLayout>
      <RewardedActivitiesPage/>
    </AbstractLayout>
  )
}

function UserManagement(){
  return(
    <AbstractLayout>
      <UserManagementPage/>
    </AbstractLayout>
  )
}

